module.exports = __webpack_public_path__ + "img/travel-t.aca085aa.png";